/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import RegistrationCompletion from './RegistrationCompletion';

export default function RegistrationCompletionPage() {
    return <RegistrationCompletion />;
}
